let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, toKebabCase } from '@utils/utils';

const elementTag = 'spw-tooltip';

const argTypes = withComponentControls(componentsData, { tag: elementTag });

const meta: Meta = {
  title: 'Composants/Infobulle (tooltip)',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Affiche des informations supplémentaires lorsque l'utilisateur survole un élément.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/748e85-infobulle-tooltip)
        `,
      },
    },
  },
};

export default meta;

function htmlContent(slot) {
  return /* HTML */ `${slot}`;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);
  const hasSlot = true;
  const slottedLabel = 'label';

  Object.entries(args).forEach(([key, val]) => {
    if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    } else {
      if (key !== slottedLabel) {
        element.setAttribute(toKebabCase(key), val as string);
      }
    }
  });

  if (hasSlot) {
    element.innerHTML = htmlContent(args[slottedLabel]);
  }

  return element;
};

export const Default = Template.bind({});
Default.args = {
  tooltipTitle: 'Mon titre',
  tooltipText: 'Mon texte',
  label: 'Mon élément déclencheur',
};
